// Define the backend url as the root for the serverless deployment, and
// as localhost:3001 if deploying locally
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ? process.env.REACT_APP_BACKEND_URL :  
  window.location.hostname === "localhost"
    ? "http://localhost:3001"
    : window.location.origin;
